<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="card-title">Pesquisas</div>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label for="Name"> ID da Unidade: </label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="filters.unidade_id"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="Name"> Nome da Unidade: </label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="filters.unidade_nome"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="Name"> Tem Telemedicina: </label>
                  <select v-model="filters.telemedicina" class="form-control">
                    <option value="null"></option>
                    <option value="1">Sim</option>
                    <option value="0">Nao</option>
                  </select>
                </div>
              </div>

              <div class="col-md-2 mt-2">
                <button class="btn btn-primary" @click="getEntity">
                  Filtrar
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Unidade ID</th>
                      <th scope="col">Nome Unidade</th>
                      <th scope="col">Tem telemedicina?</th>
                      <th scope="col">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="unidade in data" :key="unidade.id">
                      <th scope="row">{{ unidade.id }}</th>
                      <td>{{ unidade.unidade_id }}</td>
                      <td>{{ unidade.unidade_nome }}</td>
                      <td>
                        <span
                          :class="
                            unidade.telemedicina == 0
                              ? 'badge badge-pill badge-danger'
                              : 'badge badge-pill badge-success'
                          "
                          >{{ unidade.telemedicina == 0 ? "Não" : "Sim" }}</span
                        >
                      </td>
                      <td>
                        <button
                          class="btn btn-crud view"
                          @click="view(unidade)"
                        >
                          <i class="fas fa-eye"></i>
                        </button>
                        <button
                          class="btn btn-crud edit ml-1"
                          @click="preview(unidade)"
                        >
                          <i class="fas fa-globe"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                class="col-md-6 mt-1 mx-auto d-flex justify-content-center align-items-center"
              >
                <pagination
                  :records="total"
                  :options="options"
                  :per-page="15"
                  @paginate="getEntity"
                ></pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from "vue-pagination-2";
export default {
  data: function () {
    return {
      filters: {
        telemedicina: null,
        unidade_id: null,
        unidade_nome: null,
      },
      data: [],
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
      total: 0,
      page: 1,
      pages: [],
    };
  },
  components: { Pagination },
  methods: {
    view(unidade) {
      const self = this;
      self.$router.push("/perguntas/view/" + unidade.unidade_id);
    },
    preview(unidade) {
      const self = this;

      window.open(
        "https://survey.it4d.com.br/whatsapp_service/public/pesquisa/" +
          unidade.unidade_id,
        "_blank"
      );
    },
    getEntity: function (page) {
      const self = this;
      self.page = page || 1;

      const api = self.$store.state.api + "get-pesquisas?page=" + self.page;

      axios
        .post(api, self.filters)
        .then((response) => {
          self.data = response.data.data;
          self.total = response.data.total;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    self.getEntity();
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>
